import { useState } from "react";
import { Confirmation } from "./Confirmation/Confirmation";
import { NotifyMeForm } from "./NotifyMeForm/NotifyMeForm";
import { NotifiableEvent } from "../../../../../types/types";

type Props = {
  pimProductId: string;
  skuId: string;
  notifiableEventType: NotifiableEvent;
  notificationsApiBaseUrl: string;
  notificationsApiKey: string;
  isSelected: boolean;
};

export const NotifyMe = ({
  pimProductId,
  skuId,
  notifiableEventType,
  notificationsApiBaseUrl,
  notificationsApiKey,
  isSelected,
}: Props) => {
  const [notificationSent, setNotificationSent] = useState(false);

  if (isSelected && !notifiableEventType) return null;

  return (
    <>
      {notificationSent ? (
        <Confirmation />
      ) : (
        <NotifyMeForm
          pimProductId={pimProductId}
          skuId={skuId}
          onSuccess={() => setNotificationSent(true)}
          notifiableEventType={notifiableEventType}
          notificationsApiBaseUrl={notificationsApiBaseUrl}
          notificationsApiKey={notificationsApiKey}
          isSelected={isSelected}
        />
      )}
    </>
  );
};
